import {AvailableLanguageKeys, changeLanguage, defaultLanguage, tolgee} from "@/langs/tolgee";
import {ref, Ref} from "vue";

export default class LangService {
  private static instance?: LangService;
  private _lang: Ref<AvailableLanguageKeys> = ref(defaultLanguage);

  static getInstance() {
      if (typeof LangService.instance === 'undefined') {
        LangService.instance = new LangService();
      }
      return LangService.instance;
  }

  public async set(locale: string) {
    const lang = await changeLanguage(locale);
    this._lang.value = lang;
    localStorage.setItem("lang", lang);
  }

  public getLocalStorageLang(): string | null {
    return localStorage.getItem("lang")
  }

  public get() {
    return tolgee.getLanguage() ?? defaultLanguage;
  }

  public lang(): Ref<AvailableLanguageKeys> {
    return this._lang;
  }
}
